var isBrowser = typeof window !== 'undefined' && window.document != null && window.document.createElement != null;
export default isBrowser;
//# sourceMappingURL=isBrowser.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/browser-helpers/dist/esm/isBrowser.js
// module id = 300
// module chunks = 0 1